import { Component, EventEmitter, Output } from '@angular/core';
import { environment } from 'environments/environment';

/**
 * Aviso de la nueva Localización Instantánea, con el botón que lleva a ella
 * (TELE-710). Va arriba del Dashboard y de Flota completa.
 *
 * @deprecated TELE-829: el Dashboard se dio de baja para los usuarios. La ruta `#/dashboard` (y sus hijas) solo
 * redirige a la Localización Instantánea nueva (`DashboardRetiradoGuard`), así que este componente ya no se
 * muestra. Se conserva el código como respaldo: no agregarle funcionalidad.
 */
@Component({
  selector: 'app-aviso-nuevo-modulo',
  templateUrl: './aviso-nuevo-modulo.component.html',
  styleUrls: ['./aviso-nuevo-modulo.component.css']
})
export class AvisoNuevoModuloComponent {

  readonly urlNuevoModulo = environment.appLocalizacionInstantanea;

  /** El usuario cerró el aviso con la X. */
  @Output() cerrar = new EventEmitter<void>();

}
